import { render } from "./addOpportunity.vue?vue&type=template&id=129f13da&scoped=true"
import script from "./addOpportunity.vue?vue&type=script&lang=js"
export * from "./addOpportunity.vue?vue&type=script&lang=js"

import "./addOpportunity.vue?vue&type=style&index=0&id=129f13da&scoped=true&lang=css"

import exportComponent from "/var/www/html/conference/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-129f13da"]])

export default __exports__